import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _uniqueId from "lodash/uniqueId";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { STRING_TRUE, OnePerPage, emptyNoteText } from '@mummssoftware/utils/constants';
import { formatMMDDYYhh } from '@mummssoftware/utils/utils';
import parse from 'html-react-parser';
import { styles } from '../../../utils';
const tab = '\u00A0\u00A0\u00A0\u00A0\u00A0';
const bullet = '\u00b7';

const composeStyles = className => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const cssObj = {};
  if (!className) return styles;

  if (className.includes('ql-size-small')) {
    cssObj.fontSize = '8pt';
  }

  if (className.includes('ql-size-normal')) {
    cssObj.fontSize = '10pt';
  }

  if (className.includes('ql-size-large')) {
    cssObj.fontSize = '20pt';
  }

  if (className.includes('ql-size-huge')) {
    cssObj.fontSize = '30pt';
  }

  return cssObj;
};

var _ref = /*#__PURE__*/React.createElement(Text, null, bullet);

const rtfToPdf = elements => {
  const returnContentConst = [];
  React.Children.forEach(elements, element => {
    if (typeof element === 'string') {
      // Handle string content
      const lines = element.split('\n');
      lines.forEach((line, index) => {
        const formatted = line && String(line).replaceAll('\t', tab);
        returnContentConst.push( /*#__PURE__*/React.createElement(Text // eslint-disable-next-line react/no-array-index-key
        , {
          key: `line_${index}`,
          style: {
            width: '85vw'
          }
        }, formatted, " ", /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0")));
      });
    } else if ( /*#__PURE__*/React.isValidElement(element)) {
      const elementProps = element.props;
      const {
        type
      } = element;
      const children = rtfToPdf(elementProps.children);
      const style = composeStyles(elementProps.className);

      switch (type) {
        case 'strong':
          returnContentConst.push( /*#__PURE__*/React.createElement(View, {
            style: [styles.fontWeightBold, style],
            key: Math.random()
          }, children));
          break;

        case 'em':
          returnContentConst.push( /*#__PURE__*/React.createElement(View, {
            style: [styles.fontFamilyItalic, style],
            key: Math.random()
          }, children));
          break;

        case 's':
          returnContentConst.push( /*#__PURE__*/React.createElement(View, {
            style: _objectSpread({
              textDecoration: 'line-through'
            }, style),
            key: Math.random()
          }, children));
          break;

        case 'u':
          returnContentConst.push( /*#__PURE__*/React.createElement(View, {
            style: _objectSpread({
              textDecoration: 'underline'
            }, style),
            key: Math.random()
          }, children));
          break;

        case 'ol':
        case 'ul':
          returnContentConst.push( /*#__PURE__*/React.createElement(View, {
            style: _objectSpread({
              display: 'flex',
              flexDirection: 'row'
            }, style),
            key: Math.random()
          }, children));
          break;

        case 'li':
          returnContentConst.push( /*#__PURE__*/React.createElement(Text, {
            style: _objectSpread({
              marginLeft: '20pt',
              position: 'relative'
            }, style),
            key: Math.random()
          }, _ref, " ", children, "\xA0"));
          break;

        default:
          returnContentConst.push( /*#__PURE__*/React.createElement(Text, {
            key: Math.random(),
            style: style
          }, children));
          break;
      }
    }
  });
  return /*#__PURE__*/React.createElement(View, null, returnContentConst);
};

export const SingleNotePDF = ({
  pnNote,
  index,
  pdfPSOComponents,
  ordersPageConfig
}) => {
  const uniqueId = _uniqueId('reactPDF-progress-note-');

  const onePerPageFilter = ordersPageConfig === OnePerPage && pnNote.isorder === STRING_TRUE && index !== 0;
  const psoComponentById = pdfPSOComponents.find(psoComponent => Object.keys(psoComponent)[0] === pnNote.id.toString());
  const psoComponent = psoComponentById && Object.values(psoComponentById)[0];
  return pnNote.note && pnNote.note !== emptyNoteText && /*#__PURE__*/React.createElement(View, {
    key: uniqueId,
    break: onePerPageFilter
  }, psoComponentById && String(pnNote.isorder) === STRING_TRUE && psoComponent, /*#__PURE__*/React.createElement(Text, {
    style: [styles.fontSizeTenPt, styles.fontWeightBold]
  }, formatMMDDYYhh(pnNote), " - ", pnNote.personname, " ", pnNote.credentials), /*#__PURE__*/React.createElement(View, {
    style: {
      fontSize: '10pt'
    }
  }, rtfToPdf(parse(pnNote.note)))) || null;
};